if (!customElements.get('pw-lazy-video')) {
  customElements.define('pw-lazy-video', class extends HTMLElement {
    connectedCallback() {
      this.style.display = 'block';
      this.style.height = '100%';
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && this.offsetWidth) {
            const template = this.querySelector('template');
            if (template) template.replaceWith(template.content.cloneNode(true));
            const video = this.querySelector('video');
            if (video) {
              video.muted = true;
              video.play().catch(() => { video.controls = true; });
            }
          } else {
            this.querySelector('video')?.pause();
          }
        });
      }, { rootMargin: '200px 0px' });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.querySelector('video')?.pause();
    }
  });
}
